import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyDiSaHRh89ElBIN8uQ-C2lA2sgMwKUK04U',
  authDomain: 'grass-2f75a.firebaseapp.com',
  projectId: 'grass-2f75a',
  storageBucket: 'grass-2f75a.firebasestorage.app',
  messagingSenderId: '150722676670',
  appId: '1:150722676670:web:55b4d0a47ca1bc57cd9bef',
}

firebase.initializeApp(firebaseConfig)

const firebaseSideEffect = firebase.initializeApp(
  firebaseConfig,
  'Side Effect instance'
)

const db = firebase.firestore()
const storageRef = firebase.storage().ref()
const { storage } = firebase
const functions = firebase.app().functions('europe-west3')

export { db, storage, storageRef, firebase, firebaseSideEffect, functions }
